import { Flex } from "@chakra-ui/react"


export const Row = ({children, ...props}) => {
    return (
        <Flex
            as="tr"
            {...props}

        >
            {children}
        </Flex>  
    )
}